export const COMPANY_ID = 5;